import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faCartPlus, faCartShopping } from '@fortawesome/free-solid-svg-icons';

import useViewport from 'Hooks/useViewport';

export default function AddToCart({
  addingToBasket,
  disableButton,
  inCart,
  isCharity,
  oldStyle,
  onClick,
  payWhatYouWant,
  updateTier,
  upgrade,
  className,
}) {
  const { isAboveMd } = useViewport();

  let buttonIcon = 'cart-plus';
  let buttonText = 'addtocart';

  if (addingToBasket) {
    buttonIcon = 'spinner';
    buttonText = 'adding';
  }

  if (inCart) {
    buttonIcon = 'shopping-cart';
    buttonText = 'checkoutnow';
  }

  if (updateTier) {
    buttonText = 'updatetier';
  }

  if (oldStyle && isAboveMd) {
    buttonIcon = 'shopping-cart';
  }

  if (isCharity) {
    buttonText = 'selectdonation';
  }

  if (payWhatYouWant) {
    buttonText = 'paymoregivemore';
  }

  if (upgrade) {
    buttonText = 'upgrade';
  }

  return (
    <button
      className={className || classNames('ProductAddToCartButton btn-primary', { 'ProductAddToCartButton--oldStyle': oldStyle })}
      disabled={disableButton}
      onClick={() => onClick()}
    >
      <div className="ProductAddToCartButton__icon">
        {buttonIcon === 'cart-plus' &&
          <FontAwesomeIcon icon={faCartPlus} />
        }
        {buttonIcon === 'spinner' &&
          <FontAwesomeIcon icon={faSpinner} className="fa-spin" />
        }
        {buttonIcon === 'shopping-cart' &&
          <FontAwesomeIcon icon={faCartShopping} />
        }
      </div>
      <div className="ProductAddToCartButton__text">
        {buttonText === 'addtocart' &&
          <FormattedMessage id="addtocart.button.addtocart" defaultMessage="Add to cart" />
        }
        {buttonText === 'adding' &&
          <FormattedMessage id="addtocart.button.adding" defaultMessage="Adding" />
        }
        {buttonText === 'updatetier' &&
          <FormattedMessage id="addtocart.button.updatetier" defaultMessage="Update Tier in Cart" />
        }
        {buttonText === 'checkoutnow' &&
          <FormattedMessage id="addtocart.button.checkoutnow" defaultMessage="Check out now" />
        }
        {buttonText === 'selectdonation' &&
          <FormattedMessage id="addtocart.button.selectdonation" defaultMessage="Select Donation" />
        }
        {buttonText === 'paymoregivemore' &&
          <FormattedMessage id="addtocart.button.paymoregivemore" defaultMessage="Pay More, Give More" />
        }
        {buttonText === 'upgrade' &&
          <FormattedMessage id="addtocart.button.upgrade" defaultMessage="Upgrade" />
        }
      </div>
    </button>
  );
}

AddToCart.propTypes = {
  addingToBasket: PropTypes.bool,
  disableButton: PropTypes.bool,
  inCart: PropTypes.bool,
  isCharity: PropTypes.bool,
  oldStyle: PropTypes.bool,
  onClick: PropTypes.func,
  payWhatYouWant: PropTypes.bool,
  updateTier: PropTypes.bool,
  upgrade: PropTypes.bool,
  className: PropTypes.string,
};

AddToCart.defaultProps = {
  addingToBasket: false,
  disableButton: false,
  inCart: false,
  isCharity: false,
  oldStyle: false,
  payWhatYouWant: false,
  updateTier: false,
  upgrade: false,
  className: '',
};
